import { commons } from '@provise/lib/transformer'
import { result } from 'lodash-es'

export default ({ departments }) => ({
  /*
  ---------------------------------------------------------------------------
  */
  request_sent: {
    /*
      это объект одной "секции" (card верхнего уровня с заголовком)
      sectionLabel  - это заголовок секции
      form - это схема формы (как обычно)
    */
    sectionLabel: 'Информация о получении образца',
    acceptLabel: 'Подтвердить получение образца',
    form: [
      ['checkbox', 'quality_group', 'Образец получен группой по качеству'],
      ['dtpicker', 'date_receive', 'Дата получения образца'],
      ['text', 'completeness', 'Комплектность образца'],
      ['textarea', 'comment_1', 'Комментарий'],
    ],
    info: {
      date_receive: [null, mv => commons.dateLocal(mv.date_receive, 'P')],
    },
  },
  request_received: {
    sectionLabel: 'Информация об отправке образца',
    acceptLabel: 'Сохранить форму',
    info: {
      department: [null, mv => result(mv, 'department.name')],
      courier: [null, mv => result(mv, 'courier.value')],
      date_sending: [null, mv => commons.dateLocal(mv.date_sending, 'P')],
    },
    form: [
      ['dtpicker', 'date_sending', 'Дата отправки образца'],
      ['text', 'assistant', 'Ассистент'],
      ['text', 'sender', 'Отправляющий'],
      ['select-id', 'department', 'Отдел', { options: departments }],
      ['text', 'city', 'Город'],
      [
        'div',
        '__card',
        null,
        { layout: false, class: 'card g-full' },

        [
          'div',
          '__card',
          null,
          { layout: false, class: 'card-body' },
          ['div', null, null, { class: 'h5 card-title', layout: false, text: 'Данные получателя' }],
          [
            'div',
            '__card',
            null,
            { class: 'form-schema' },
            ['text', 'receiver_lastname', 'Фамилия получателя'],
            ['text', 'company', 'Название компании'],
            ['text', 'address', 'Точный адрес получателя'],
            ['text', 'phone', 'Телефон получателя'],
          ],
        ],
      ],
      ['textarea', 'comment_2', 'Содержание отправки'],
      [
        'select',
        'courier',
        'Курьерская служба',
        { options: 'transfers.courier', return: 'id-object' },
      ],
      ['text', 'weight', 'Вес, кг', { validate: 'float' }],
      ['text', 'invoice', 'Номер накладной'],
      ['text', 'amount', 'Сумма', { validate: 'float' }],
      ['text', 'account', 'Account'],
      ['text', 'cost', 'Cost Centre'],
      ['text', 'product', 'Product'],
      ['text', 'activity', 'Activity'],
    ],
  },
  transfer_started: {
    acceptLabel: 'Отправить на ресепшн',
    form: [
      ['checkbox', 'transferred', 'Образец передан'],
      [
        'div',
        '__reception',
        null,
        { layout: 'mb-3' },
        ['text', 'email_reception', 'e-mail ресепшн', { required: 1 }],
        [
          'div',
          '__helpText',
          null,
          { class: 'form-text', text: 'Необходимо заполнить перед отправкой' },
        ],
      ],
    ],
  },
})
